<template>
    <div v-if="menuItems?.length" class="site-top-menu px-4">
        <v-slide-group show-arrows="mobile">
            <v-slide-group-item v-for="item in menuItems" :key="item.id">
                <div :class="compactMode ? 'px-4' : 'px-8'">
                    <v-btn
                        variant="text"
                        :active="activeMenuItem === item.id"
                        class="px-2 rounded-0 text-h5"
                        :class="{ 'font-weight-bold': activeMenuItem === item.id }"
                        :href="item.childPages?.length ? undefined : item.link"
                        :target="item.isExternalLink ? '_blank' : undefined"
                        @click="item.childPages?.length && (activeMenuItem = item.id)"
                    >
                        {{ item.displayName }}
                    </v-btn>
                </div>
            </v-slide-group-item>
        </v-slide-group>
    </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { VBtn, VSlideGroup, VSlideGroupItem } from 'vuetify/components';
import { MenuPageLink } from '../../composables/MenuProvider';

interface Props {
    menuItems?: MenuPageLink[];
    selectedMenuItem?: number;
    compactMode?: boolean;
}

const props = defineProps<Props>();
const activeMenuItem = useVModel(props, 'selectedMenuItem');
</script>

<style lang="scss">
.site-top-menu {
    min-width: 300px;

    .v-btn {
        &.v-btn--active {
            border-bottom: 3px solid var(--v-color-green);

            .v-btn__overlay {
                opacity: 0;
            }
        }
    }
}
</style>
